/* A Stripe Dashboard link for any Stripe id.
 *
 * Stripe ids say what they are in their prefix, so the common ones go straight
 * to their own page. Everything else — an id type not listed here, an email, a
 * bare amount — goes to the Dashboard's own search, which finds any object by
 * id, so an unknown prefix still lands on the right thing, one click later.
 *
 * Ids carry no live/test marker, so the caller says which: a live id opened
 * under /test/ (or the reverse) is a "not found" page, not a redirect. */

const PAGES = {
  pi_: "payments", // PaymentIntent — what our orders are keyed by
  ch_: "payments", // Charge — the payments page takes these too
  py_: "payments", // Non-card payment (bank debits)
  cus_: "customers",
  in_: "invoices",
  sub_: "subscriptions",
  po_: "payouts",
  evt_: "events",
};

const BASE = "https://dashboard.stripe.com";

export function stripeUrl(raw, { test = false } = {}) {
  const id = String(raw || "").trim();
  if (!id) return null;
  const root = test ? `${BASE}/test` : BASE;
  const prefix = Object.keys(PAGES).find(
    (p) => id.startsWith(p) && /^[A-Za-z0-9_]+$/.test(id)
  );
  return prefix
    ? `${root}/${PAGES[prefix]}/${id}`
    : `${root}/search?query=${encodeURIComponent(id)}`;
}
